import React, { useState } from "react";
import { DateRangePicker } from "react-date-range";
import "react-date-range/dist/styles.css"; // main style file
import "../../components/LeadDataReport/LeadDataReport.css";
import axios from "axios";
import ExcelExport from "../ExcelExport/ExcelExport";
import Loader from "../../components/Loader/loader";
import filterIcon from "../../Icons/filterIcon.png";
import CryptoJS from 'crypto-js';

const LeadDataReport = () => {

  const [showFilterDiv, setShowFilterDiv] = useState(false);

  const toggleFilterDiv = () => {
    setShowFilterDiv(!showFilterDiv); // This will toggle the visibility of the div
  };

  const [loading, setLoading] = useState(false);
  const [originCountryResponse, setOriginCountryResponse] = useState([]);

  const [regionData, setRegionData] = useState("");

  const [leadSourceData, setLeadSourceData] = useState("");
  const [leadSourceResponse, setLeadSourceResponse] = useState([]);

  const [petTypeResponse, setPetTypeResponse] = useState([]);
  const [petBreedResponse, setPetBreedResponse] = useState([]);

  const [originOpenLeadStage, setOriginOpenLeadStage] = useState("");
  const [openleadstageResponse, setOpenleadstageResponse] = useState([]);

  const [originCloseLeadStage, setOriginCloseLeadStage] = useState("");
  const [closeleadstageResponse, setCloseleadstageResponse] = useState([]);

  const [originConvertedStage, setOriginConvertedStage] = useState("");
  const [convertedstageResponse, setConvertedStageResponse] = useState([]);

  const [findUsData, setFindUsData] = useState("");
  const [todayStatus, setTodayStatus] = useState("0");
  const [leadStatusData, setLeadStatusData] = useState("");
  const [serviceTypeData, setServiceTypeData] = useState("");
  const [regionListName, setRegionListName] = useState("");
  const [serviceTypeResponse, setServiceTypeResponse] = useState([]);
  const [originStateResponse, setOriginStateResponse] = useState([]);
  const [destinationStateResponse, setDestinationStateResponse] = useState([]);
  const [originCityResponse, setOriginCityResponse] = useState([]);
  const [destinationCityResponse, setDestinationCityResponse] = useState([]);
  const [City, setCity] = useState("");

  const [leadResponse, setLeadResponse] = useState([]);

  const [inputDataValue, setInputDataValue] = useState("");
  const [subStageResponse, setSubStageResponse] = useState([]);

  const baseAPI = process.env.REACT_APP_API_URL;

  const [formData, setFormData] = useState({
    fromDate: "",
    toDate: "",
    leadEntryDate: "",
    lastUpdatedDate: "",
    followUpDate: "",
    relocationDate: "",
    queryID: "",
    name: "",
    phone: "",
    email: "",
    password: "",
    country: "",
    state: "",
    city: "",
    originCountry: "",
    originState: "",
    originCity: "",
    origin_pin: "",
    destination_pin: "",
    openleadstage: "",
    closedleadstage: "",
    convertedstatus: "",
    petType: "",
    petBreed: "",
    sub_stage: ""
  });

  const [selectedAttributeInput, setSelectedAttributeInput] = useState("");

  const handleChangeAttributeInput = (event) => {
    setSelectedAttributeInput(event.target.value);
  };

  const region = ["International", "Domestic"];
  const serviceType = [
    "International",
    "Domestic",
    "Microchip",
    "Titer Test",
    "IATA Pet Crate",
    "Pet Taxi",
  ];
  const [assignedTo, setAssignedTo] = useState("");
  const isAdmin = localStorage.getItem("isAdmin");
  const [assignToResponse, setAssignToResponse] = useState([]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  const [isOpen, setIsOpen] = useState(false);

  const [dateRange, setDateRange] = useState('Custom Dates');
  const [selectedAttributeDate, setSelectedAttributeDate] = useState("");
  const [selectionRange, setSelectionRange] = useState({
    startDate: new Date(),
    endDate: new Date(),
    key: "selection",
  });

  const togglePicker = () => {
    setIsOpen(!isOpen);
  };

  const renderDateRangePicker = () => {
    return (
      isOpen && (
        <div
          style={{
            position: "absolute",
            zIndex: 999,
            border: "solid 1px black",
            marginLeft: "1rem",
            width: "35pc",
            background: "white",
          }}
        >
          <DateRangePicker ranges={[selectionRange]} onChange={handleSelect} />
          <button
            onClick={handleApplyFilter}
            style={{
              marginBottom: "1rem",
              width: "8rem",
              height: "2.5rem",
              borderRadius: "0.5rem",
              fontSize: "13px",
              position: "relative",
              top: "1px",
              left: "19pc",
              backgroundColor: "#5B489D",
              color: "White",
              border: "none",
            }}
          >
            Apply Filter
          </button>
          <button
            onClick={handleClearFilter}
            style={{
              marginBottom: "1rem",
              width: "7.5rem",
              height: "2.5rem",
              borderRadius: "0.5rem",
              fontSize: "13px",
              position: "relative",
              top: "1px",
              left: "19pc",
              color: "red",
              backgroundColor: "white",
              border: "none",
              fontWeight: "bold",
            }}
          >
            Clear Filter
          </button>
        </div>
      )
    );
  };

  function formatDate(dateString) {
    const date = new Date(dateString);
    const options = { day: "2-digit", month: "short", year: "numeric" };
    return date.toLocaleDateString("en-US", options);
  }

  const handleApplyFilter = () => {
    setDateRange(
      formatDate(selectionRange.startDate) +
      " - " +
      formatDate(selectionRange.endDate)
    );
    setIsOpen(false);
    // You can perform additional actions here based on the selected attribute and date range
  };

  const handleClearFilter = () => {
    setDateRange('');
    setSelectedAttributeDate('');
    setIsOpen(false);
    setSelectionRange({
      startDate: new Date(),
      endDate: new Date(),
      key: 'selection',
    });
  };

  const handleSelect = (ranges) => {
    setSelectionRange(ranges.selection);
  };

  const handleChangeAttribute = (event) => {
    setSelectedAttributeDate(event.target.value);
  };

  function getLeadStage(statusid) {
    const storedToken = JSON.parse(localStorage.getItem("token"));
    axios
      .get(`${baseAPI}adminget/GETStages?StageID=0&StatusID=` + statusid, {
        headers: {
          Authorization: "Bearer " + storedToken,
        },
      })
      .then((response) => {
        if (statusid === 1) {
          setOpenleadstageResponse(response.data.data);
        } else if (statusid === 2) {
          setCloseleadstageResponse(response.data.data);
        } else if (statusid === 3) {
          setConvertedStageResponse(response.data.data);
        }
      });
  }
  const getCountry = async () => {
    const storedToken = JSON.parse(localStorage.getItem("token"));

    if (storedToken) {
      axios
        .get(`${baseAPI}adminget/GETCountry?countryID=0`, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        })
        .then((response) => {
          setOriginCountryResponse(response.data.data);
        })
        .catch((error) => {
          console.error("Error fetching Country detail:", error);
        });
    }
  };
  function getState(country_id, type) {
    if (country_id !== null && country_id !== "0") {
      const storedToken = JSON.parse(localStorage.getItem("token"));
      axios
        .get(`${baseAPI}adminget/GETState?stateID=0&countryID=` + country_id, {
          headers: {
            Authorization: "Bearer " + storedToken,
          },
        })
        .then((response) => {
          if (type === 1) {
            setOriginStateResponse(response.data.data);
          } else if (type === 2) {
            setDestinationStateResponse(response.data.data);
          }
        });
    }
  }

  function getEmployeeByDepartment() {
    const storedToken = JSON.parse(localStorage.getItem("token"));

    axios
      .get(`${baseAPI}adminget/GETEmployeeByDepartment?department_id=3`, {
        headers: {
          Authorization: `Bearer ${storedToken}`,
        },
      })
      .then((response) => {
        setAssignToResponse(response.data.data);
      })
      .catch((error) => {
        console.error("Error fetching user detail:", error);
      });
  }

  function getCity(state_id, type) {
    if (state_id !== null && state_id !== "0") {
      const storedToken = JSON.parse(localStorage.getItem("token"));
      axios
        .get(`${baseAPI}adminget/GETCity?cityID=0&stateID=` + state_id, {
          headers: {
            Authorization: "Bearer " + storedToken,
          },
        })
        .then((response) => {
          if (type === 1) {
            setOriginCityResponse(response.data.data);
          } else if (type === 2) {
            setDestinationCityResponse(response.data.data);
          }
        });
    }
  }
  const leadSource = async () => {
    const storedToken = JSON.parse(localStorage.getItem("token"));

    if (storedToken) {
      axios
        .get(`${baseAPI}adminget/GETLeadSource?LeadSourceID=0`, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        })
        .then((response) => {
          setLeadSourceResponse(response.data.data);
        })
        .catch((error) => {
          console.error("Error fetching Lead Source detail:", error);
        });
    }
  };
  function getPetType() {
    const storedToken = JSON.parse(localStorage.getItem("token"));
    if (storedToken) {
      axios
        .get(`${baseAPI}adminget/GEPetType?PetType=0`, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        })
        .then((response) => {
          setPetTypeResponse(response.data.data);
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  }
  function getPetBreed(pet_type) {
    if (pet_type === null || pet_type === "") {
      pet_type = 0;
    }

    const storedToken = JSON.parse(localStorage.getItem("token"));
    axios
      .get(
        `${baseAPI}adminget/GEPetBreedType?PetBreedID=0&PetType=` + pet_type,
        {
          headers: {
            Authorization: "Bearer " + storedToken,
          },
        }
      )
      .then((response) => {
        setPetBreedResponse(response.data.data);
      });
  }

  function getServiceType() {
    const storedToken = JSON.parse(localStorage.getItem("token"));

    axios
      .get(`${baseAPI}adminget/GetServiceType`, {
        headers: {
          Authorization: `Bearer ${storedToken}`,
        },
      })
      .then((response) => {
        setServiceTypeResponse(response.data.data);

      })
      .catch((error) => {
        console.error("Error fetching user detail:", error);
      });
  }



  function getLeadDataButton() {
    getLeadData();
  }

  function getLeadData() {
    setLoading(true);
    const storedToken = JSON.parse(localStorage.getItem("token"));
    let startdate = formatDate(selectionRange.startDate);

    let enddate = formatDate(selectionRange.endDate);
    if (dateRange === "Custom Dates") {
      startdate = '';
      enddate = '';
    }

    if (storedToken) {
      axios
        .get(
          `${baseAPI}userget/GetLeadDdataReport?dateAttribute=${selectedAttributeDate}&startDate=${startdate}&enddate=${enddate}&entryType=${selectedAttributeInput}&openLeadStage=${originOpenLeadStage}&closeLeadStage=${originCloseLeadStage}&leadSource=${leadSourceData}&leadStatus=${leadStatusData}&whereFindUs=${findUsData}&serviceType=${serviceTypeData}&searchParam=${inputDataValue}&leadregion=${regionData}&originCountry=${formData.originCountry}&originState=${formData.originState}&originCity=${City}&originPin=${formData.origin_pin}&destinationCountry=${formData.country}&destinationState=${formData.state}&destinationCity=${formData.city}&destinationPin=${formData.destination_pin}&petType=${formData.petType}&petBreed=${formData.petBreed}&emailSearch=${assignedTo}&subStage=${formData.sub_stage}&region_name=${regionListName}&todayStatus=${todayStatus}`,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          if (response) {
            setLeadResponse(response.data.data);
          }
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        })
        .finally(() => {
          setLoading(false); // Set loading to false when data is fetched
        });
    }
  }

  const resetForm = () => {
    setSelectedAttributeDate("");
    setDateRange("");
    setSelectedAttributeInput("");
    setOriginOpenLeadStage("");
    setOriginCloseLeadStage("");
    setLeadSourceData("");
    setLeadStatusData("");
    setFindUsData("");
    setOriginConvertedStage("");
    setServiceTypeData("");
    setRegionData("");
    setCity("");
    setInputDataValue("");
    setAssignedTo("");
    setRegionListName("");
    setFormData({
      originCountry: "",
      originState: "",
      origin_pin: "",
      country: "",
      state: "",
      city: "",
      destination_pin: "",
      petType: "",
      petBreed: "",
      sub_stage: ""
    });
    setSelectionRange({
      startDate: new Date(),
      endDate: new Date(),
      key: 'selection',
    });
  };

  const handleSelectChangeOriginCountry = (event) => {
    formData.originCountry = event.target.value;
    getState(event.target.value, 1);
  };

  const handleSelectChangeOriginState = (event) => {
    formData.originState = event.target.value;
    getCity(event.target.value, 1);
  };

  const handleSelectChangeDestinationCountry = (event) => {
    formData.country = event.target.value;
    getState(event.target.value, 2);
  };

  const handleSelectChangeDestinationState = (event) => {
    formData.state = event.target.value;
    getCity(event.target.value, 2);
  };

  const handleSelectRegion = (event) => {
    setRegionData(event.target.value);
  };

  const handleSelectChangePetType = (event) => {
    formData.petType = event.target.value;
    getPetBreed(event.target.value);
  };

  const handleWhereFindUs = (event) => {
    setFindUsData(event.target.value);
  };

  const handleTodayStatus = (event) => {
    setTodayStatus(event.target.value);
  };


  const handleRegionListName = (event) => {
    setRegionListName(event.target.value);
  };

  const handleLeadStatus = (event) => {
    setLeadStatusData(event.target.value);
  };

  const handleServiceType = (event) => {
    setServiceTypeData(event.target.value);
  };

  const handleChangePetBreed = (event) => {
    const selectedPetBreed = event.target.value;

    setFormData({
      ...formData,
      petBreed: selectedPetBreed, // Update the petBreed value
    });
  };

  const handleSelectChange = (event) => {
    setLeadSourceData(event.target.value);
  };
  const handleSearchParamChange = (event) => {
    setInputDataValue(event.target.value);
  };

  const itemsPerPage = 50;
  const [currentPage, setCurrentPage] = useState(1);
  const [sortedColumn, setSortedColumn] = useState(null);
  const [sortOrder, setSortOrder] = useState("asc"); // Default sort order is ascending

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;

  // Add a null check using the optional chaining operator (?.)
  const visibleData = leadResponse?.slice(startIndex, endIndex);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  function convertToSortableString(dateStr) {
    const months = {
      Jan: "01",
      Feb: "02",
      Mar: "03",
      Apr: "04",
      May: "05",
      Jun: "06",
      Jul: "07",
      Aug: "08",
      Sep: "09",
      Oct: "10",
      Nov: "11",
      Dec: "12",
    };
    const parts = dateStr.match(
      /(\w{3}) (\d{2}) (\d{4}) (\d{2}):(\d{2})(AM|PM)/
    );

    if (!parts) {
      console.error("Date format is incorrect:", dateStr);
      return ""; // Or handle this case as needed
    }

    const year = parts[3];
    const month = months[parts[1]];
    const day = parts[2].padStart(2, "0");
    let hour = parseInt(parts[4], 10);
    const minute = parts[5];

    // Adjust for AM/PM
    if (parts[6] === "PM" && hour < 12) hour += 12;
    if (parts[6] === "AM" && hour === 12) hour = 0;

    hour = hour.toString().padStart(2, "0");

    return `${year}${month}${day}${hour}${minute}`;
  }

  const sortAndToggleOrder = (column) => {
    // Determine the new sort order
    const newSortOrder =
      sortedColumn !== column || sortOrder === "desc" ? "asc" : "desc";

    let sortedData = [...leadResponse];
    // Sorting logic here (adjusted to use newSortOrder)
    if (column === "lead_id") {
      sortedData.sort((a, b) => {
        // Your sorting logic...
        const valA = a[column];
        const valB = b[column];
        if (!isNaN(valA) && !isNaN(valB)) {
          // Numeric comparison
          return newSortOrder === "asc" ? valA - valB : valB - valA;
        } else {
          // Fallback to string comparison if values aren't numeric
          return newSortOrder === "asc"
            ? String(valA).localeCompare(String(valB))
            : String(valB).localeCompare(String(valA));
        }
      });
    } else if (column === "lead_entry_date") {
      sortedData.sort((a, b) => {
        const dateA = convertToSortableString(a.lead_entry_date);
        const dateB = convertToSortableString(b.lead_entry_date);

        return newSortOrder === "asc"
          ? dateA.localeCompare(dateB)
          : dateB.localeCompare(dateA);
      });
    } else if (column === "assigned_to") {
      sortedData.sort((a, b) => {
        // Your sorting logic...
        const assignedToA = a.assigned_to || "";
        const assignedToB = b.assigned_to || "";
        if (assignedToA === assignedToB) {
          return 0;
        }
        if (assignedToA === "" && newSortOrder === "asc") {
          return 1;
        }
        if (assignedToB === "" && newSortOrder === "asc") {
          return -1;
        }
        return newSortOrder === "asc"
          ? assignedToA.localeCompare(assignedToB)
          : assignedToB.localeCompare(assignedToA);
      });
    } else if (column === "first_name") {
      sortedData.sort((a, b) => {
        const firstNameA = a.first_name || "";
        const firstNameB = b.first_name || "";
        // Handle case where one or both names are empty
        if (!firstNameA && !firstNameB) return 0;
        if (!firstNameA) return 1;
        if (!firstNameB) return -1;

        // Sort alphabetically
        return newSortOrder === "asc"
          ? firstNameA.localeCompare(firstNameB)
          : firstNameB.localeCompare(firstNameA);
      });
    } else if (column === "last_name") {
      sortedData.sort((a, b) => {
        const lastNameA = a.last_name || "";
        const lastNameB = b.last_name || "";

        // Handle case where one or both names are empty
        if (!lastNameA && !lastNameB) return 0;
        if (!lastNameA) return 1;
        if (!lastNameB) return -1;

        // Compare first names alphabetically
        return newSortOrder === "asc"
          ? lastNameA.localeCompare(lastNameB)
          : lastNameB.localeCompare(lastNameA);
      });
    } else if (column === "mobile_no") {
      sortedData.sort((a, b) => {
        const mobileA = a.mobile_no || "";
        const mobileB = b.mobile_no || "";

        // Handle case where one or both mobile numbers are empty
        if (!mobileA && !mobileB) return 0;
        if (!mobileA) return 1;
        if (!mobileB) return -1;

        // Compare mobile numbers based on sort order
        return newSortOrder === "asc"
          ? mobileA.localeCompare(mobileB)
          : mobileB.localeCompare(mobileA);
      });
    } else if (column === "alternate_number") {
      sortedData.sort((a, b) => {
        const alternateNumberA = a.alternate_number || "";
        const alternateNumberB = b.alternate_number || "";

        // Handle case where one or both alternateNumber numbers are empty
        if (!alternateNumberA && !alternateNumberB) return 0;
        if (!alternateNumberA) return 1;
        if (!alternateNumberB) return -1;

        // Compare alternateNumber numbers based on sort order
        return newSortOrder === "asc"
          ? alternateNumberA.localeCompare(alternateNumberB)
          : alternateNumberB.localeCompare(alternateNumberA);
      });
    }
    else if (column === "email") {
      sortedData.sort((a, b) => {
        const emailA = a.email || "";
        const emailB = b.email || "";

        // Handle case where one or both emails are empty
        if (!emailA && !emailB) return 0;
        if (!emailA) return 1;
        if (!emailB) return -1;

        // Compare emails based on sort order
        return newSortOrder === "asc"
          ? emailA.localeCompare(emailB)
          : emailB.localeCompare(emailA);
      });
    } else if (column === "leadsource") {
      sortedData.sort((a, b) => {
        const leadSourceA = a.leadsource || "";
        const leadSourceB = b.leadsource || "";

        // Handle case where one or both names are empty
        if (!leadSourceA && !leadSourceB) return 0;
        if (!leadSourceA) return 1;
        if (!leadSourceB) return -1;

        // Compare first names alphabetically
        return newSortOrder === "asc"
          ? leadSourceA.localeCompare(leadSourceB)
          : leadSourceB.localeCompare(leadSourceA);
      });
    } else if (column === "lead_region") {
      sortedData.sort((a, b) => {
        const leadRegionA = a.lead_region || "";
        const leadRegionB = b.lead_region || "";

        // Handle case where one or both names are empty
        if (!leadRegionA && !leadRegionB) return 0;
        if (!leadRegionA) return 1;
        if (!leadRegionB) return -1;

        // Compare first names alphabetically
        return newSortOrder === "asc"
          ? leadRegionA.localeCompare(leadRegionB)
          : leadRegionB.localeCompare(leadRegionA);
      });
    } else if (column === "status_name") {
      sortedData.sort((a, b) => {
        const statusNameA = a.status_name || "";
        const statusNameB = b.status_name || "";

        // Handle case where one or both names are empty
        if (!statusNameA && !statusNameB) return 0;
        if (!statusNameA) return 1;
        if (!statusNameB) return -1;

        // Compare first names alphabetically
        return newSortOrder === "asc"
          ? statusNameA.localeCompare(statusNameB)
          : statusNameB.localeCompare(statusNameA);
      });
    } else if (column === "openLeadStage") {
      sortedData.sort((a, b) => {
        const openLeadStageA = a.openLeadStage || "";
        const openLeadStageB = b.openLeadStage || "";

        // Handle case where one or both names are empty
        if (!openLeadStageA && !openLeadStageB) return 0;
        if (!openLeadStageA) return 1;
        if (!openLeadStageB) return -1;

        // Compare first names alphabetically
        return newSortOrder === "asc"
          ? openLeadStageA.localeCompare(openLeadStageB)
          : openLeadStageB.localeCompare(openLeadStageA);
      });
    } else if (column === "closedLeadStage") {
      sortedData.sort((a, b) => {
        const closedLeadStageA = a.closedLeadStage || "";
        const closedLeadStageB = b.closedLeadStage || "";

        // Handle case where one or both names are empty
        if (!closedLeadStageA && !closedLeadStageB) return 0;
        if (!closedLeadStageA) return 1;
        if (!closedLeadStageB) return -1;

        // Compare first names alphabetically
        return newSortOrder === "asc"
          ? closedLeadStageA.localeCompare(closedLeadStageB)
          : closedLeadStageB.localeCompare(closedLeadStageA);
      });
    } else if (column === "service_type") {
      sortedData.sort((a, b) => {
        const serviceTypeA = a.service_type || "";
        const serviceTypeB = b.service_type || "";

        // Handle case where one or both names are empty
        if (!serviceTypeA && !serviceTypeB) return 0;
        if (!serviceTypeA) return 1;
        if (!serviceTypeB) return -1;

        // Compare first names alphabetically
        return newSortOrder === "asc"
          ? serviceTypeA.localeCompare(serviceTypeB)
          : serviceTypeB.localeCompare(serviceTypeA);
      });
    } else if (column === "from_where") {
      sortedData.sort((a, b) => {
        const fromWhereA = a.from_where || "";
        const fromWhereB = b.from_where || "";

        // Handle case where one or both names are empty
        if (!fromWhereA && !fromWhereB) return 0;
        if (!fromWhereA) return 1;
        if (!fromWhereB) return -1;

        // Compare first names alphabetically
        return newSortOrder === "asc"
          ? fromWhereA.localeCompare(fromWhereB)
          : fromWhereB.localeCompare(fromWhereA);
      });
    } else if (column === "origin_country") {
      sortedData.sort((a, b) => {
        const originCountryA = a.origin_country || "";
        const originCountryB = b.origin_country || "";

        // Handle case where one or both names are empty
        if (!originCountryA && !originCountryB) return 0;
        if (!originCountryA) return 1;
        if (!originCountryB) return -1;

        // Compare first names alphabetically
        return newSortOrder === "asc"
          ? originCountryA.localeCompare(originCountryB)
          : originCountryB.localeCompare(originCountryA);
      });
    } else if (column === "origin_state") {
      sortedData.sort((a, b) => {
        const originStateA = a.origin_state || "";
        const originStateB = b.origin_state || "";

        // Handle case where one or both names are empty
        if (!originStateA && !originStateB) return 0;
        if (!originStateA) return 1;
        if (!originStateB) return -1;

        // Compare first names alphabetically
        return newSortOrder === "asc"
          ? originStateA.localeCompare(originStateB)
          : originStateB.localeCompare(originStateA);
      });
    } else if (column === "origin_city") {
      sortedData.sort((a, b) => {
        const originCityA = a.origin_city || "";
        const originCityB = b.origin_city || "";

        // Handle case where one or both names are empty
        if (!originCityA && !originCityB) return 0;
        if (!originCityA) return 1;
        if (!originCityB) return -1;

        // Compare first names alphabetically
        return newSortOrder === "asc"
          ? originCityA.localeCompare(originCityB)
          : originCityB.localeCompare(originCityA);
      });
    } else if (column === "destination_country") {
      sortedData.sort((a, b) => {
        const destinationCountryA = a.destination_country || "";
        const destinationCountryB = b.destination_country || "";

        // Handle case where one or both names are empty
        if (!destinationCountryA && !destinationCountryB) return 0;
        if (!destinationCountryA) return 1;
        if (!destinationCountryB) return -1;

        // Compare first names alphabetically
        return newSortOrder === "asc"
          ? destinationCountryA.localeCompare(destinationCountryB)
          : destinationCountryB.localeCompare(destinationCountryA);
      });
    } else if (column === "destination_state") {
      sortedData.sort((a, b) => {
        const destinationStateA = a.destination_state || "";
        const destinationStateB = b.destination_state || "";

        // Handle case where one or both names are empty
        if (!destinationStateA && !destinationStateB) return 0;
        if (!destinationStateA) return 1;
        if (!destinationStateB) return -1;

        // Compare first names alphabetically
        return newSortOrder === "asc"
          ? destinationStateA.localeCompare(destinationStateB)
          : destinationStateB.localeCompare(destinationStateA);
      });
    } else if (column === "destination_city") {
      sortedData.sort((a, b) => {
        const destinationCityA = a.destination_city || "";
        const destinationCityB = b.destination_city || "";

        // Handle case where one or both names are empty
        if (!destinationCityA && !destinationCityB) return 0;
        if (!destinationCityA) return 1;
        if (!destinationCityB) return -1;

        // Compare first names alphabetically
        return newSortOrder === "asc"
          ? destinationCityA.localeCompare(destinationCityB)
          : destinationCityB.localeCompare(destinationCityA);
      });
    } else if (column === "pet_type") {
      sortedData.sort((a, b) => {
        const petTypeA = a.pet_type || "";
        const petTypeB = b.pet_type || "";

        // Handle case where one or both names are empty
        if (!petTypeA && !petTypeB) return 0;
        if (!petTypeA) return 1;
        if (!petTypeB) return -1;

        // Compare first names alphabetically
        return newSortOrder === "asc"
          ? petTypeA.localeCompare(petTypeB)
          : petTypeB.localeCompare(petTypeA);
      });
    } else if (column === "pet_breed") {
      sortedData.sort((a, b) => {
        const petBreedA = a.pet_breed || "";
        const petBreedB = b.pet_breed || "";

        // Handle case where one or both names are empty
        if (!petBreedA && !petBreedB) return 0;
        if (!petBreedA) return 1;
        if (!petBreedB) return -1;

        // Compare first names alphabetically
        return newSortOrder === "asc"
          ? petBreedA.localeCompare(petBreedB)
          : petBreedB.localeCompare(petBreedA);
      });
    } else if (column === "number_of_pets") {
      sortedData.sort((a, b) => {
        // Attempt to parse integers if they are not already, this handles string numbers.
        const numPetsA = parseInt(a.number_of_pets, 10);
        const numPetsB = parseInt(b.number_of_pets, 10);
        // Check if parsing was successful; log or handle any NaN results here if necessary.
        if (isNaN(numPetsA) || isNaN(numPetsB)) {
          console.error("Error parsing number_of_pets:", {
            numPetsA,
            numPetsB,
          });
          return 0; // Decide on how to handle non-numeric values, perhaps sort them to the end or start.
        }
        // Perform the sort based on the newSortOrder
        if (newSortOrder === "asc") {
          return numPetsA - numPetsB;
        } else {
          return numPetsB - numPetsA;
        }
      });
    } else if (column === "pet_height") {
      sortedData.sort((a, b) => {
        // Your sorting logic...
        const valA = a[column];
        const valB = b[column];
        if (!isNaN(valA) && !isNaN(valB)) {
          // Numeric comparison
          return newSortOrder === "asc" ? valA - valB : valB - valA;
        } else {
          // Fallback to string comparison if values aren't numeric
          return newSortOrder === "asc"
            ? String(valA).localeCompare(String(valB))
            : String(valB).localeCompare(String(valA));
        }
      });
    } else if (column === "pet_width") {
      sortedData.sort((a, b) => {
        // Your sorting logic...
        const valA = a[column];
        const valB = b[column];
        if (!isNaN(valA) && !isNaN(valB)) {
          // Numeric comparison
          return newSortOrder === "asc" ? valA - valB : valB - valA;
        } else {
          // Fallback to string comparison if values aren't numeric
          return newSortOrder === "asc"
            ? String(valA).localeCompare(String(valB))
            : String(valB).localeCompare(String(valA));
        }
      });
    } else if (column === "pet_age") {
      sortedData.sort((a, b) => {
        // Attempt to parse integers if they are not already, this handles string numbers.
        const petAgeA = parseInt(a.pet_age, 10);
        const petAgeB = parseInt(b.pet_age, 10);
        // Check if parsing was successful; log or handle any NaN results here if necessary.
        if (isNaN(petAgeA) || isNaN(petAgeB)) {
          console.error("Error parsing pet_age:", { petAgeA, petAgeB });
          return 0; // Decide on how to handle non-numeric values, perhaps sort them to the end or start.
        }
        // Perform the sort based on the newSortOrder
        if (newSortOrder === "asc") {
          return petAgeA - petAgeB;
        } else {
          return petAgeB - petAgeA;
        }
      });
    } else if (column === "gender") {
      sortedData.sort((a, b) => {
        const genderA = a.gender || "";
        const genderB = b.gender || "";

        // Handle case where one or both names are empty
        if (!genderA && !genderB) return 0;
        if (!genderA) return 1;
        if (!genderB) return -1;

        // Compare first names alphabetically
        return newSortOrder === "asc"
          ? genderA.localeCompare(genderB)
          : genderB.localeCompare(genderA);
      });
    } else if (column === "relocation_purpose") {
      sortedData.sort((a, b) => {
        const relocationPurposeA = a.relocation_purpose || "";
        const relocationPurposeB = b.relocation_purpose || "";

        // Handle case where one or both names are empty
        if (!relocationPurposeA && !relocationPurposeB) return 0;
        if (!relocationPurposeA) return 1;
        if (!relocationPurposeB) return -1;

        // Compare first names alphabetically
        return newSortOrder === "asc"
          ? relocationPurposeA.localeCompare(relocationPurposeB)
          : relocationPurposeB.localeCompare(relocationPurposeA);
      });
    }
    else if (column === "mode_of_transport") {
      sortedData.sort((a, b) => {
        // Your sorting logic...
        const valA = a[column];
        const valB = b[column];
        if (!isNaN(valA) && !isNaN(valB)) {
          // Numeric comparison
          return newSortOrder === "asc" ? valA - valB : valB - valA;
        } else {
          // Fallback to string comparison if values aren't numeric
          return newSortOrder === "asc"
            ? String(valA).localeCompare(String(valB))
            : String(valB).localeCompare(String(valA));
        }
      });
    } else if (column === "pick_up_distance") {
      sortedData.sort((a, b) => {
        // Your sorting logic...
        const valA = a[column];
        const valB = b[column];
        if (!isNaN(valA) && !isNaN(valB)) {
          // Numeric comparison
          return newSortOrder === "asc" ? valA - valB : valB - valA;
        } else {
          // Fallback to string comparison if values aren't numeric
          return newSortOrder === "asc"
            ? String(valA).localeCompare(String(valB))
            : String(valB).localeCompare(String(valA));
        }
      });
    } else if (column === "drop_distance") {
      sortedData.sort((a, b) => {
        // Your sorting logic...
        const valA = a[column];
        const valB = b[column];
        if (!isNaN(valA) && !isNaN(valB)) {
          // Numeric comparison
          return newSortOrder === "asc" ? valA - valB : valB - valA;
        } else {
          // Fallback to string comparison if values aren't numeric
          return newSortOrder === "asc"
            ? String(valA).localeCompare(String(valB))
            : String(valB).localeCompare(String(valA));
        }
      });
    } else if (column === "pet_Name") {
      sortedData.sort((a, b) => {
        const petNameA = a.pet_Name || "";
        const petNameB = b.pet_Name || "";

        // Handle case where one or both names are empty
        if (!petNameA && !petNameB) return 0;
        if (!petNameA) return 1;
        if (!petNameB) return -1;

        // Compare first names alphabetically
        return newSortOrder === "asc"
          ? petNameA.localeCompare(petNameB)
          : petNameB.localeCompare(petNameA);
      });
    } else if (column === "pet_behaviour") {
      sortedData.sort((a, b) => {
        const petBehaviourA = a.pet_behaviour || "";
        const petBehaviourB = b.pet_behaviour || "";

        // Handle case where one or both names are empty
        if (!petBehaviourA && !petBehaviourB) return 0;
        if (!petBehaviourA) return 1;
        if (!petBehaviourB) return -1;

        // Compare first names alphabetically
        return newSortOrder === "asc"
          ? petBehaviourA.localeCompare(petBehaviourB)
          : petBehaviourB.localeCompare(petBehaviourA);
      });
    } else if (column === "relocation_detail") {
      sortedData.sort((a, b) => {
        const relocationDetailA = a.relocation_detail || "";
        const relocationDetailB = b.relocation_detail || "";

        // Handle case where one or both names are empty
        if (!relocationDetailA && !relocationDetailB) return 0;
        if (!relocationDetailA) return 1;
        if (!relocationDetailB) return -1;

        // Compare first names alphabetically
        return newSortOrder === "asc"
          ? relocationDetailA.localeCompare(relocationDetailB)
          : relocationDetailB.localeCompare(relocationDetailA);
      });
    } else if (column === "container_lengtd") {
      sortedData.sort((a, b) => {
        // Your sorting logic...
        const valA = a[column];
        const valB = b[column];
        if (!isNaN(valA) && !isNaN(valB)) {
          // Numeric comparison
          return newSortOrder === "asc" ? valA - valB : valB - valA;
        } else {
          // Fallback to string comparison if values aren't numeric
          return newSortOrder === "asc"
            ? String(valA).localeCompare(String(valB))
            : String(valB).localeCompare(String(valA));
        }
      });
    } else if (column === "pet_gender") {
      sortedData.sort((a, b) => {
        const petGenderA = a.pet_gender || "";
        const petGenderB = b.pet_gender || "";

        // Handle case where one or both names are empty
        if (!petGenderA && !petGenderB) return 0;
        if (!petGenderA) return 1;
        if (!petGenderB) return -1;

        // Compare first names alphabetically
        return newSortOrder === "asc"
          ? petGenderA.localeCompare(petGenderB)
          : petGenderB.localeCompare(petGenderA);
      });
    }
    else if (column === "remark") {
      sortedData.sort((a, b) => {
        const remarkA = a.remark || "";
        const remarkB = b.remark || "";

        // Handle case where one or both names are empty
        if (!remarkA && !remarkB) return 0;
        if (!remarkA) return 1;
        if (!remarkB) return -1;

        // Compare first names alphabetically
        return newSortOrder === "asc"
          ? remarkA.localeCompare(remarkB)
          : remarkB.localeCompare(remarkA);
      });
    } else if (column === "total_followups") {
      sortedData.sort((a, b) => {
        // Your sorting logic...
        const valA = a[column];
        const valB = b[column];
        // Handle case where one or both mobile numbers are empty
        if (!valA && !valB) return 0;
        if (!valA) return 1;
        if (!valB) return -1;
        if (!isNaN(valA) && !isNaN(valB)) {
          // Numeric comparison
          return newSortOrder === "asc" ? valA - valB : valB - valA;
        } else {
          // Fallback to string comparison if values aren't numeric
          return newSortOrder === "asc"
            ? String(valA).localeCompare(String(valB))
            : String(valB).localeCompare(String(valA));
        }
      });
    } else if (column === "subject") {
      sortedData.sort((a, b) => {
        const subjectA = a.subject || "";
        const subjectB = b.subject || "";

        // Handle case where one or both names are empty
        if (!subjectA && !subjectB) return 0;
        if (!subjectA) return 1;
        if (!subjectB) return -1;

        // Compare first names alphabetically
        return newSortOrder === "asc"
          ? subjectA.localeCompare(subjectB)
          : subjectB.localeCompare(subjectA);
      });
    }
    else if (column === "lead_owner") {
      sortedData.sort((a, b) => {
        const leadOwnerA = a.lead_owner || "";
        const leadOwnerB = b.lead_owner || "";

        // Handle case where one or both names are empty
        if (!leadOwnerA && !leadOwnerB) return 0;
        if (!leadOwnerA) return 1;
        if (!leadOwnerB) return -1;

        // Compare first names alphabetically
        return newSortOrder === "asc"
          ? leadOwnerA.localeCompare(leadOwnerB)
          : leadOwnerB.localeCompare(leadOwnerA);
      });
    } else if (column === "call_status") {
      sortedData.sort((a, b) => {
        const callStatusA = a.call_status || "";
        const callStatusB = b.call_status || "";

        // Handle case where one or both names are empty
        if (!callStatusA && !callStatusB) return 0;
        if (!callStatusA) return 1;
        if (!callStatusB) return -1;

        // Compare first names alphabetically
        return newSortOrder === "asc"
          ? callStatusA.localeCompare(callStatusB)
          : callStatusB.localeCompare(callStatusA);
      });
    } else if (column === "call_duration") {
      sortedData.sort((a, b) => {
        // Your sorting logic...
        const valA = a[column];
        const valB = b[column];
        // Handle case where one or both mobile numbers are empty
        if (!valA && !valB) return 0;
        if (!valA) return 1;
        if (!valB) return -1;
        if (!isNaN(valA) && !isNaN(valB)) {
          // Numeric comparison
          return newSortOrder === "asc" ? valA - valB : valB - valA;
        } else {
          // Fallback to string comparison if values aren't numeric
          return newSortOrder === "asc"
            ? String(valA).localeCompare(String(valB))
            : String(valB).localeCompare(String(valA));
        }
      });
    } else if (column === "department_name") {
      sortedData.sort((a, b) => {
        const departmentNameA = a.department_name || "";
        const departmentNameB = b.department_name || "";

        // Handle case where one or both names are empty
        if (!departmentNameA && !departmentNameB) return 0;
        if (!departmentNameA) return 1;
        if (!departmentNameB) return -1;

        // Compare first names alphabetically
        return newSortOrder === "asc"
          ? departmentNameA.localeCompare(departmentNameB)
          : departmentNameB.localeCompare(departmentNameA);
      });
    } else if (column === "description") {
      sortedData.sort((a, b) => {
        const descriptionA = a.description || "";
        const descriptionB = b.description || "";

        // Handle case where one or both names are empty
        if (!descriptionA && !descriptionB) return 0;
        if (!descriptionA) return 1;
        if (!descriptionB) return -1;

        // Compare first names alphabetically
        return newSortOrder === "asc"
          ? descriptionA.localeCompare(descriptionB)
          : descriptionB.localeCompare(descriptionA);
      });
    }
    else if (column === "pet_length") {
      sortedData.sort((a, b) => {
        // Your sorting logic...
        const valA = a[column];
        const valB = b[column];
        // Handle case where one or both mobile numbers are empty
        if (!valA && !valB) return 0;
        if (!valA) return 1;
        if (!valB) return -1;
        if (!isNaN(valA) && !isNaN(valB)) {
          // Numeric comparison
          return newSortOrder === "asc" ? valA - valB : valB - valA;
        } else {
          // Fallback to string comparison if values aren't numeric
          return newSortOrder === "asc"
            ? String(valA).localeCompare(String(valB))
            : String(valB).localeCompare(String(valA));
        }

      });
    }
    else if (column === "substage_name") {
      sortedData.sort((a, b) => {
        // Your sorting logic...
        const substageNameA = a.substage_name || "";
        const substageNameB = b.substage_name || "";
        if (substageNameA === substageNameB) {
          return 0;
        }
        if (substageNameA === "" && newSortOrder === "asc") {
          return 1;
        }
        if (substageNameB === "" && newSortOrder === "asc") {
          return -1;
        }
        return newSortOrder === "asc"
          ? substageNameA.localeCompare(substageNameB)
          : substageNameB.localeCompare(substageNameA);
      });
    }
    else if (column === "region_name") {
      sortedData.sort((a, b) => {
        // Your sorting logic...
        const regionNameA = a.region_name || "";
        const regionNameB = b.region_name || "";
        if (regionNameA === regionNameB) {
          return 0;
        }
        if (regionNameA === "" && newSortOrder === "asc") {
          return 1;
        }
        if (regionNameB === "" && newSortOrder === "asc") {
          return -1;
        }
        return newSortOrder === "asc"
          ? regionNameA.localeCompare(regionNameB)
          : regionNameB.localeCompare(regionNameA);
      });
    }

    // Apply the state updates
    setLeadResponse(sortedData);
    setSortedColumn(column);
    setSortOrder(newSortOrder);
  };
  function getStatusColor(statusName) {
    switch (statusName) {
      case "untouched":
        return "orange";
      case "open":
        return "#28A745";
      case "closed":
        return "#DC3545";
      case "Converted":
        return "#87CEEB";
      default:
        return "white";
    }
  }

  function getLeadSubStage(stage_id) {
    const storedToken = JSON.parse(localStorage.getItem("token"));
    axios
      .get(`${baseAPI}adminget/GETSubStages?stage_id=` + stage_id, {
        headers: {
          Authorization: "Bearer " + storedToken,
        },
      })
      .then((response) => {
        setSubStageResponse(response.data.data);
      });
  }

  const handleChangeOPenClose = (e) => {
    const { name, value } = e.target;
    getLeadSubStage(e.target.value);

    if (name === "openLead" && value !== "0") {
      setOriginOpenLeadStage(e.target.value);
      setOriginCloseLeadStage("");
    }
    else if (name === "closeLead" && value !== "0") {
      setOriginCloseLeadStage(e.target.value);
      setOriginOpenLeadStage("");
    }
  };

  function nextPage1(Relocation_ID) {

    const key = 'dbbworldwidepvtltd';
    const encryptedRelocationID = encryptRelocationID(Relocation_ID, key);

    const url = `/viewleaddetail?Relocation_ID=${encryptedRelocationID}`;
    window.open(url, '_blank');
  }

  function encryptRelocationID(Relocation_ID, key) {
    const ciphertext = CryptoJS.AES.encrypt(Relocation_ID.toString(), key).toString();
    return encodeURIComponent(ciphertext);
  }



  return (
    <>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <button onClick={toggleFilterDiv} className="filterButton">
          <img src={filterIcon} />
          {" "}FILTER
        </button>
        <div style={{ display: "flex" }}
        ><p
          className="icon"
          style={{
            borderColor: "#5B489D",
            border: "2px solid #5B489D",
            textAlign: "center",
            padding: "7px",
            fontSize: "18px",
            fontWeight: "bold",
            width: "11rem",
            height: "3rem",
            borderRadius: "0.5rem",
            color: "#6A6A6A",
            backgroundColor: "white",
            marginRight: "13px",
          }}
        >
            {" "}
            {leadResponse.length === 0 ? (
              <span>0 Records</span>
            ) : (
              <span>{leadResponse.length} Records</span>
            )}
          </p>

          {isAdmin === "true" && (<ExcelExport leadResponse={leadResponse} />)}
        </div>
      </div>


      {showFilterDiv && (
        <form onSubmit={handleSubmit} className="formContainer">
          <div className="container" style={{ padding: "0px" }}>
            <div className="row">
              <div className="col fixArrow">
                <select
                  value={selectedAttributeDate}
                  onChange={handleChangeAttribute}
                  className="form-control optionSize "
                >
                  <option value="">Date Attribute</option>

                  <option value="1">Lead Entry Date</option>
                  <option value="2">Last Update Date</option>
                  <option value="3">Follow Up Date</option>
                  <option value="4">Relocation Date</option>
                  <option value="5">Pet DOB</option>
                  <option value="6">Conversion Date</option>
                </select>
                <span
                  className="arrow"
                  style={{
                    position: "relative",
                    marginLeft: "-32px",
                    marginTop: "14px",
                    color: "#BFBFBF",
                  }}
                >
                  &#9660;
                </span>
              </div>
              <div className="col fixArrow">
                {/* <div style={{ paddingRight: "6px" }}> */}
                <button
                  className="form-control optionSize"
                  style={{
                    // marginBottom: "1rem",
                    width: "15.6rem",
                    height: "2.5rem",
                    borderRadius: "0.4rem",
                    fontSize: "14px",
                    textAlign: "left",
                  }}
                  onClick={togglePicker}
                >
                  {dateRange || "Custom Date Range"}
                </button>
                <span
                  className="arrow"
                  style={{
                    position: "relative",
                    marginLeft: "-32px",
                    marginTop: "14px",
                    color: "#BFBFBF",
                  }}
                >
                  &#9660;
                </span>
                {renderDateRangePicker()}
                {/* </div> */}
              </div>

              <div className="col fixArrow">
                <select
                  value={selectedAttributeInput}
                  onChange={handleChangeAttributeInput}
                  className="form-control optionSize"
                >
                  <option value=""> Entry Type</option>
                  <option value="1">Query ID</option>
                  <option value="2">Name</option>
                  <option value="3">Phone</option>
                  <option value="4">Email</option>
                </select>
                <span
                  className="arrow"
                  style={{
                    position: "relative",
                    marginLeft: "-32px",
                    marginTop: "14px",
                    color: "#BFBFBF",
                  }}
                >
                  &#9660;
                </span>
              </div>
              <div className="col fixArrow">
                <input
                  type="text"
                  id={selectedAttributeInput}
                  name={selectedAttributeInput}
                  value={inputDataValue}
                  onChange={handleSearchParamChange}
                  className="form-control optionSize"
                  placeholder={
                    selectedAttributeInput === "1"
                      ? "Query ID"
                      : selectedAttributeInput === "2"
                        ? "Name"
                        : selectedAttributeInput === "3"
                          ? "Phone"
                          : selectedAttributeInput === "4"
                            ? "Email"
                            : ""
                  }
                />
              </div>
            </div>

            <div className="row">
              <div className="col fixArrow">
                <select
                  id="openLead"
                  name="openLead"
                  value={originOpenLeadStage}
                  onChange={handleChangeOPenClose}
                  className="form-control optionSize"
                  placeholder="Select Open Lead Stage"
                  onClick={() => getLeadStage(1)}
                >
                  <option value=""> Open Lead Stage</option>
                  {openleadstageResponse.map((item) => (
                    <option key={item.stageid} value={item.stageid}>
                      {item.stagename}
                    </option>
                  ))}
                </select>
                <span
                  className="arrow"
                  style={{
                    position: "relative",
                    marginLeft: "-32px",
                    marginTop: "14px",
                    color: "#BFBFBF",
                  }}
                >
                  &#9660;
                </span>
              </div>
              <div className="col fixArrow">
                <select
                  id="closeLead"
                  name="closeLead"
                  value={originCloseLeadStage}
                  onChange={handleChangeOPenClose}
                  className="form-control optionSize"
                  placeholder="Select Close Lead Stage"
                  onClick={() => getLeadStage(2)}
                >
                  <option value=""> Close Lead Stage</option>
                  {closeleadstageResponse.map((item) => (
                    <option key={item.stageid} value={item.stageid}>
                      {item.stagename}
                    </option>
                  ))}
                </select>
                <span
                  className="arrow"
                  style={{
                    position: "relative",
                    marginLeft: "-32px",
                    marginTop: "14px",
                    color: "#BFBFBF",
                  }}
                >
                  &#9660;
                </span>
              </div>
              <div className="col fixArrow">
                <select
                  id="sub_stage"
                  name="sub_stage"
                  value={formData.sub_stage}
                  onChange={handleChange}
                  className="form-control optionSize"
                >
                  <option value=""> Sub Stages</option>
                  {subStageResponse.map((substage) => (
                    <option
                      key={substage.substage_id}
                      value={substage.substage_id}
                    >
                      {substage.substage_name}
                    </option>
                  ))}
                </select>
                <span
                  className="arrow"
                  style={{
                    position: "relative",
                    marginLeft: "-32px",
                    marginTop: "14px",
                    color: "#BFBFBF",
                  }}
                >
                  &#9660;
                </span>
              </div>
              <div className="col fixArrow">
                <select
                  id="leadStatus"
                  name="leadStatus"
                  value={leadStatusData}
                  onChange={handleLeadStatus}
                  className="form-control optionSize"
                  placeholder="City or Region"
                >
                  <option value=""> Lead Status</option>
                  <option value="0">Untouched</option>
                  <option value="1">Open</option>
                  <option value="2">Closed</option>
                  <option value="3">Converted</option>
                </select>
                <span
                  className="arrow"
                  style={{
                    position: "relative",
                    marginLeft: "-32px",
                    marginTop: "14px",
                    color: "#BFBFBF",
                  }}
                >
                  &#9660;
                </span>
              </div>
            </div>

            <div className="row">
              <div className="col fixArrow">
                <select
                  id="whereFindUs"
                  name="whereFindUs"
                  value={findUsData}
                  onChange={handleWhereFindUs}
                  className="form-control optionSize"
                >
                  <option value=""> Where Find Us</option>
                  <option value="1">Facebook</option>
                  <option value="2">Instagram</option>
                  <option value="3">LinkedIn</option>
                  <option value="4">Through Existing User</option>
                  <option value="5">Friends and Family</option>
                  <option value="6">While Searching on Google</option>
                </select>
                <span
                  className="arrow"
                  style={{
                    position: "relative",
                    marginLeft: "-32px",
                    marginTop: "14px",
                    color: "#BFBFBF",
                  }}
                >
                  &#9660;
                </span>
              </div>
              <div className="col fixArrow">
                <select
                  id="convertedStatus"
                  name="convertedStatus"
                  value={originConvertedStage}
                  onChange={(e) => setOriginConvertedStage(e.target.value)}
                  className="form-control optionSize"
                  placeholder="City or Region"
                  onClick={() => getLeadStage(3)}
                >
                  <option value=""> Converted Status</option>
                  {convertedstageResponse.map((item) => (
                    <option key={item.stageid} value={item.stageid}>
                      {item.stagename}
                    </option>
                  ))}
                </select>
                <span
                  className="arrow"
                  style={{
                    position: "relative",
                    marginLeft: "-32px",
                    marginTop: "14px",
                    color: "#BFBFBF",
                  }}
                >
                  &#9660;
                </span>
              </div>
              <div className="col fixArrow">
                <select
                  id="serviceType"
                  name="serviceType"
                  value={serviceTypeData}
                  onChange={handleServiceType}
                  className="form-control optionSize"
                  placeholder="City or Region"
                  onClick={getServiceType}
                >
                  <option value=""> Service Type</option>
                  {serviceTypeResponse !== null ? (
                    serviceTypeResponse.map((item) => (
                      <option value={item.service_type}>
                        {item.ServiceTypeName}
                      </option>
                    ))
                  ) : (
                    <p>empty</p>
                  )}
                </select>
                <span
                  className="arrow"
                  style={{
                    position: "relative",
                    marginLeft: "-32px",
                    marginTop: "14px",
                    color: "#BFBFBF",
                  }}
                >
                  &#9660;
                </span>
              </div>
              <div className="col fixArrow">
                <select
                  id="region"
                  name="region"
                  value={regionData}
                  onChange={handleSelectRegion}
                  className="form-control optionSize"
                  placeholder="Select Region"
                >
                  <option value=""> Lead Type</option>
                  {region.map((region, index) => (
                    <option key={index} value={region}>
                      {region}
                    </option>
                  ))}
                </select>
                <span
                  className="arrow"
                  style={{
                    position: "relative",
                    marginLeft: "-32px",
                    marginTop: "14px",
                    color: "#BFBFBF",
                  }}
                >
                  &#9660;
                </span>
              </div>
            </div>

            <div className="row">
              <div className="col fixArrow">
                <select
                  id="originCountrySelect"
                  name="originCountrySelect"
                  onChange={handleSelectChangeOriginCountry}
                  value={formData.originCountry}
                  className="form-control optionSize"
                  onClick={getCountry}
                >
                  <option value=""> Origin Country</option>
                  {originCountryResponse.map((country) => (
                    <option key={country} value={country.id}>
                      {country.name}
                    </option>
                  ))}
                </select>
                <span
                  className="arrow"
                  style={{
                    position: "relative",
                    marginLeft: "-32px",
                    marginTop: "14px",
                    color: "#BFBFBF",
                  }}
                >
                  &#9660;
                </span>
              </div>
              <div className="col fixArrow">
                <select
                  id="originState"
                  name="originState"
                  value={formData.originState}
                  onChange={handleSelectChangeOriginState}
                  className="form-control optionSize"
                  placeholder="City or Region"
                >
                  <option value=""> Origin State</option>
                  {originStateResponse.map((item) => (
                    <option value={item.state_id}>{item.stateName}</option>
                  ))}
                </select>
                <span
                  className="arrow"
                  style={{
                    position: "relative",
                    marginLeft: "-32px",
                    marginTop: "14px",
                    color: "#BFBFBF",
                  }}
                >
                  &#9660;
                </span>
              </div>
              <div className="col fixArrow">
                <select
                  id="city"
                  name="city"
                  value={City}
                  onChange={(e) => setCity(e.target.value)}
                  className="form-control optionSize"
                  placeholder="City or Region"
                >
                  <option value=""> Origin City</option>
                  {originCityResponse.map((item) => (
                    <option value={item.id}>{item.name}</option>
                  ))}
                </select>
                <span
                  className="arrow"
                  style={{
                    position: "relative",
                    marginLeft: "-32px",
                    marginTop: "14px",
                    color: "#BFBFBF",
                  }}
                >
                  &#9660;
                </span>
              </div>
              <div className="col fixArrow">
                <input
                  type="text"
                  id=""
                  name="origin_pin"
                  value={formData.origin_pin}
                  onChange={handleChange}
                  className="form-control optionSize"
                  placeholder="Enter Origin Pin"
                />
              </div>
            </div>

            <div className="row">
              <div className="col fixArrow">
                <select
                  id="destinationCountry"
                  name="destinationCountry"
                  value={formData.country}
                  onChange={handleSelectChangeDestinationCountry}
                  className="form-control optionSize"
                  placeholder="City or Region"
                  onClick={getCountry}
                >
                  <option value=""> Destination Country</option>
                  {originCountryResponse.map((country) => (
                    <option key={country} value={country.id}>
                      {country.name}
                    </option>
                  ))}
                </select>
                <span
                  className="arrow"
                  style={{
                    position: "relative",
                    marginLeft: "-32px",
                    marginTop: "14px",
                    color: "#BFBFBF",
                  }}
                >
                  &#9660;
                </span>
              </div>
              <div className="col fixArrow">
                <select
                  id="state"
                  name="state"
                  value={formData.state}
                  onChange={handleSelectChangeDestinationState}
                  className="form-control optionSize"
                  placeholder="City or Region"
                >
                  <option value=""> Destination State</option>
                  {destinationStateResponse.map((item) => (
                    <option value={item.state_id}>{item.stateName}</option>
                  ))}
                </select>
                <span
                  className="arrow"
                  style={{
                    position: "relative",
                    marginLeft: "-32px",
                    marginTop: "14px",
                    color: "#BFBFBF",
                  }}
                >
                  &#9660;
                </span>
              </div>
              <div className="col fixArrow">
                <select
                  id="city"
                  name="city"
                  value={formData.city}
                  onChange={handleChange}
                  className="form-control optionSize"
                  placeholder="City or Region"
                >
                  <option value=""> Destination City</option>
                  {destinationCityResponse !== null &&
                    destinationCityResponse !== undefined ? (
                    destinationCityResponse.map((item) => (
                      <option value={item.id}>
                        {item.name}
                      </option>
                    ))
                  ) : (
                    <p>empty</p>
                  )}
                </select>
                <span
                  className="arrow"
                  style={{
                    position: "relative",
                    marginLeft: "-32px",
                    marginTop: "14px",
                    color: "#BFBFBF",
                  }}
                >
                  &#9660;
                </span>
              </div>
              <div className="col fixArrow">
                <input
                  type="text"
                  id=""
                  name="destination_pin"
                  value={formData.destination_pin}
                  onChange={handleChange}
                  className="form-control optionSize"
                  placeholder="Enter Destination Pin"
                />
              </div>
            </div>
            <div className="row">
              <div className="col fixArrow">
                <select
                  id="petTypeSelect"
                  name="petType"
                  type="text"
                  value={formData.petType}
                  onChange={handleSelectChangePetType}
                  className="form-control optionSize"
                  onClick={getPetType}
                >
                  <option value="0"> Pet Type</option>
                  {petTypeResponse.map((item) => (
                    <option value={item.id}>{item.petType}</option>
                  ))}
                </select>
                <span
                  className="arrow"
                  style={{
                    position: "relative",
                    marginLeft: "-32px",
                    marginTop: "14px",
                    color: "#BFBFBF",
                  }}
                >
                  &#9660;
                </span>
              </div>
              <div className="col fixArrow">
                <select
                  id="petBreedSelect"
                  name="PetBreedType"
                  value={formData.petBreed}
                  onChange={handleChangePetBreed}
                  className="form-control optionSize"
                  placeholder="Pet Breed"
                >
                  <option value=""> Pet Breed</option>
                  {petBreedResponse.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.PetBreedType}
                    </option>
                  ))}
                </select>
                <span
                  className="arrow"
                  style={{
                    position: "relative",
                    marginLeft: "-32px",
                    marginTop: "14px",
                    color: "#BFBFBF",
                  }}
                >
                  &#9660;
                </span>
              </div>

              <div className="col fixArrow">
                <select
                  id="regionList"
                  name="regionList"
                  value={regionListName}
                  onChange={handleRegionListName}
                  className="form-control optionSize"
                >
                  <option value=""> Region Name</option>
                  <option value="1">North</option>
                  <option value="2">East</option>
                  <option value="3">West</option>
                  <option value="4">South</option>
                </select>
                <span
                  className="arrow"
                  style={{
                    position: "relative",
                    marginLeft: "-32px",
                    marginTop: "14px",
                    color: "#BFBFBF",
                  }}
                >
                  &#9660;
                </span>
              </div>
              <div className="col fixArrow">
                <select
                  id="leadSource"
                  name="leadSource"
                  value={leadSourceData}
                  onChange={handleSelectChange}
                  className="form-control optionSize"
                  placeholder="City or Region"
                  onClick={leadSource}
                >
                  <option value=""> Lead Source</option>
                  {leadSourceResponse.map((leadsource) => (
                    <option
                      key={leadsource.leadsourceid}
                      value={leadsource.leadsourceid}
                    >
                      {leadsource.LeadSource}
                    </option>
                  ))}
                </select>
                <span
                  className="arrow"
                  style={{
                    position: "relative",
                    marginLeft: "-32px",
                    marginTop: "14px",
                    color: "#BFBFBF",
                  }}
                >
                  &#9660;
                </span>
              </div>
            </div>
            <div className="row">
              <div className="col fixArrow">
                <select
                  id="todayStatus"
                  name="todayStatus"
                  value={todayStatus}
                  onChange={handleTodayStatus}
                  className="form-control optionSize"
                >
                  <option value="0"> Select</option>
                  <option value="10">Today's Task</option>
                  <option value="4">Today's Leads</option>
                  <option value="5">Today's Followup</option>
                  <option value="8">Missed Followup</option>
                </select>
                <span
                  className="arrow"
                  style={{
                    position: "relative",
                    marginLeft: "-32px",
                    marginTop: "14px",
                    color: "#BFBFBF",
                  }}
                >
                  &#9660;
                </span>
              </div>

              <div className="col fixArrow">
                {isAdmin === "true" && (
                  <>
                    <select
                      id="assignto"
                      className="form-control optionSize"
                      name="assignto"
                      value={assignedTo}
                      onChange={(e) => setAssignedTo(e.target.value)}
                      onClick={getEmployeeByDepartment}
                    >
                      <option value="0">Assigned To</option>
                      {assignToResponse.map((item) => (
                        <option value={item.customer_id}>{item.name}</option>
                      ))}
                    </select>

                    <span
                      className="arrow"
                      style={{
                        position: "relative",
                        marginLeft: "-32px",
                        marginTop: "14px",
                        color: "#BFBFBF",
                      }}
                    >
                      &#9660;
                    </span>
                  </>
                )}
              </div>

              <div className="col fixArrow"></div>
              <div className="col fixArrow"></div>
            </div>
            <hr></hr>
            <div className="row">
              <div className="ApplyClearButton">
                <button
                  type="submit"
                  className="btn btn-danger"
                  onClick={resetForm}
                  style={{
                    marginTop: "12px",
                    border: "none",
                    color: "red",
                    backgroundColor: "white",
                    height: "47px",
                    width: "8rem",
                    fontWeight: "bold",
                  }}
                >
                  Clear Filter
                </button>
                <button
                  type="submit"
                  className="btn btn-primary applyButtonFilter"
                  onClick={getLeadDataButton}
                  style={{
                    marginTop: "12px",
                    marginLeft: "13px",
                    paddingTop: "1px",
                    height: "47px",
                    width: "8rem",
                  }}
                >
                  Apply
                </button>
              </div>

            </div>
          </div>
        </form>
      )}
      <br></br>
      <div className="headingLeadReport">
        <p>Lead Report</p>
      </div>
      <div
        className="container-fluid"
        style={{ width: "100%", overflowX: "auto", marginLeft: "-9px" }}
      >
        <div className="petBreedList">
          <table>
            <thead>
              <tr
                className="petBreedListHeading"
                style={{
                  whiteSpace: "nowrap",
                  position: "sticky",
                  top: 0,
                  zIndex: 1,
                }}
              >
                <th>Sr. No</th>
                <th onClick={() => sortAndToggleOrder("lead_id")}>Lead ID{" "}{sortedColumn === "lead_id" && (<span>{sortOrder === "asc" ? "↑" : "↓"}</span>)}{" "}</th>
                <th>Lead Entry Date </th>
                <th>Lead Last Update Date</th>
                <th>Follow up date</th>
                <th>Next Follow up date</th>
                <th>Relocation Date</th>
                <th onClick={() => sortAndToggleOrder("total_followups")}>
                  Total follow-up{" "}
                  {sortedColumn === "total_followups" && (
                    <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                  )}
                </th>
                <th onClick={() => sortAndToggleOrder("lead_owner")}>
                  Lead Owner{" "}
                  {sortedColumn === "lead_owner" && (
                    <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                  )}
                </th>
                <th onClick={() => sortAndToggleOrder("service_type")}>
                  Service Type{" "}
                  {sortedColumn === "service_type" && (
                    <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                  )}
                </th>
                <th onClick={() => sortAndToggleOrder("lead_region")}>
                  Lead Type{" "}
                  {sortedColumn === "lead_region" && (
                    <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                  )}
                </th>
                <th onClick={() => sortAndToggleOrder("leadsource")}>
                  Lead Source{" "}
                  {sortedColumn === "leadsource" && (
                    <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                  )}
                </th>
                <th onClick={() => sortAndToggleOrder("status_name")}>
                  Status{" "}
                  {sortedColumn === "status_name" && (
                    <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                  )}
                </th>
                <th onClick={() => sortAndToggleOrder("openLeadStage")}>
                  Open Lead Stage{" "}
                  {sortedColumn === "openLeadStage" && (
                    <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                  )}
                </th>
                <th onClick={() => sortAndToggleOrder("closedLeadStage")}>
                  Close Lead Stage{" "}
                  {sortedColumn === "closedLeadStage" && (
                    <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                  )}
                </th>
                <th onClick={() => sortAndToggleOrder("call_status")}>
                  Call Status{" "}
                  {sortedColumn === "call_status" && (
                    <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                  )}
                </th>
                <th onClick={() => sortAndToggleOrder("call_duration")}>
                  Call Duration{" "}
                  {sortedColumn === "call_duration" && (
                    <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                  )}
                </th>
                <th onClick={() => sortAndToggleOrder("department_name")}>
                  Department Name{" "}
                  {sortedColumn === "department_name" && (
                    <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                  )}
                </th>
                <th onClick={() => sortAndToggleOrder("description")}>
                  Description{" "}
                  {sortedColumn === "description" && (
                    <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                  )}
                </th>
                <th onClick={() => sortAndToggleOrder("relocation_purpose")}>
                  Purpose of Relocation{" "}
                  {sortedColumn === "relocation_purpose" && (
                    <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                  )}
                </th>
                <th onClick={() => sortAndToggleOrder("from_where")}>
                  From Where{" "}
                  {sortedColumn === "from_where" && (
                    <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                  )}
                </th>
                <th onClick={() => sortAndToggleOrder("first_name")}>
                  First Name{" "}
                  {sortedColumn === "first_name" && (
                    <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                  )}
                </th>
                <th onClick={() => sortAndToggleOrder("last_name")}>
                  Last Name{" "}
                  {sortedColumn === "last_name" && (
                    <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                  )}
                </th>

                <th onClick={() => sortAndToggleOrder("gender")}>
                  Gender{" "}
                  {sortedColumn === "gender" && (
                    <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                  )}
                </th>
                <th onClick={() => sortAndToggleOrder("email")}>
                  Email{" "}
                  {sortedColumn === "email" && (
                    <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                  )}
                </th>
                <th onClick={() => sortAndToggleOrder("mobile_no")}>
                  Mobile{" "}
                  {sortedColumn === "mobile_no" && (
                    <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                  )}
                </th>
                <th onClick={() => sortAndToggleOrder("alternate_number")}>
                  Alternate Number{" "}
                  {sortedColumn === "alternate_number" && (
                    <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                  )}
                </th>
                <th onClick={() => sortAndToggleOrder("pet_Name")}>
                  Pet Name{" "}
                  {sortedColumn === "pet_Name" && (
                    <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                  )}
                </th>
                <th onClick={() => sortAndToggleOrder("pet_type")}>
                  Pet Type{" "}
                  {sortedColumn === "pet_type" && (
                    <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                  )}
                </th>
                <th onClick={() => sortAndToggleOrder("pet_breed")}>
                  Pet Breed{" "}
                  {sortedColumn === "pet_breed" && (
                    <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                  )}
                </th>
                <th onClick={() => sortAndToggleOrder("pet_gender")}>
                  Pet Gender{" "}
                  {sortedColumn === "pet_gender" && (
                    <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                  )}
                </th>
                <th>Pet DOB</th>
                <th onClick={() => sortAndToggleOrder("pet_age")}>
                  Pet Age{" "}
                  {sortedColumn === "pet_age" && (
                    <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                  )}
                </th>
                <th onClick={() => sortAndToggleOrder("number_of_pets")}>
                  Pet count{" "}
                  {sortedColumn === "number_of_pets" && (
                    <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                  )}
                </th>
                <th onClick={() => sortAndToggleOrder("pet_behaviour")}>
                  Pet Behaviour{" "}
                  {sortedColumn === "pet_behaviour" && (
                    <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                  )}
                </th>
                <th onClick={() => sortAndToggleOrder("pet_length")}>
                  Pet Length{" "}
                  {sortedColumn === "pet_length" && (
                    <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                  )}
                </th>
                <th onClick={() => sortAndToggleOrder("pet_height")}>
                  Pet Height(D){" "}
                  {sortedColumn === "pet_height" && (
                    <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                  )}
                </th>
                <th onClick={() => sortAndToggleOrder("container_length")}>
                  Height(B){" "}
                  {sortedColumn === "container_length" && (
                    <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                  )}
                </th>

                <th onClick={() => sortAndToggleOrder("pet_width")}>
                  Pet Width{" "}
                  {sortedColumn === "pet_width" && (
                    <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                  )}
                </th>
                <th onClick={() => sortAndToggleOrder("origin_country")}>
                  Origin Country{" "}
                  {sortedColumn === "origin_country" && (
                    <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                  )}
                </th>
                <th onClick={() => sortAndToggleOrder("origin_state")}>
                  Origin State{" "}
                  {sortedColumn === "origin_state" && (
                    <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                  )}
                </th>
                <th onClick={() => sortAndToggleOrder("origin_city")}>
                  Origin City{" "}
                  {sortedColumn === "origin_city" && (
                    <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                  )}
                </th>
                <th>Origin Pin</th>
                <th onClick={() => sortAndToggleOrder("destination_country")}>
                  Destination Country{" "}
                  {sortedColumn === "destination_country" && (
                    <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                  )}
                </th>
                <th onClick={() => sortAndToggleOrder("destination_state")}>
                  Destination state{" "}
                  {sortedColumn === "destination_state" && (
                    <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                  )}
                </th>
                <th onClick={() => sortAndToggleOrder("destination_city")}>
                  Destination City{" "}
                  {sortedColumn === "destination_city" && (
                    <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                  )}
                </th>
                <th>Destination Pin</th>
                <th>Available Slot</th>
                <th onClick={() => sortAndToggleOrder("mode_of_transport")}>
                  Mode of Transportation{" "}
                  {sortedColumn === "mode_of_transport" && (
                    <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                  )}
                </th>
                <th onClick={() => sortAndToggleOrder("relocation_detail")}>
                  Relocation Detail{" "}
                  {sortedColumn === "relocation_detail" && (
                    <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                  )}
                </th>
                <th onClick={() => sortAndToggleOrder("pick_up_distance")}>
                  Pickup distance{" "}
                  {sortedColumn === "pick_up_distance" && (
                    <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                  )}
                </th>
                <th onClick={() => sortAndToggleOrder("drop_distance")}>
                  Drop Distance{" "}
                  {sortedColumn === "drop_distance" && (
                    <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                  )}
                </th>
                {/* check for container length */}
                <th onClick={() => sortAndToggleOrder("container_length")}>
                  Container length{" "}
                  {sortedColumn === "container_lengtd" && (
                    <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                  )}
                </th>

                <th onClick={() => sortAndToggleOrder("subject")}>
                  Follow Up Remark{" "}
                  {sortedColumn === "subject" && (
                    <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                  )}
                </th>
                <th onClick={() => sortAndToggleOrder("remark")}>
                  Remark{" "}
                  {sortedColumn === "remark" && (
                    <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                  )}
                </th>

                <th onClick={() => sortAndToggleOrder("assigned_to")}>
                  Assigned To{" "}
                  {sortedColumn === "assigned_to" && (
                    <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                  )}{" "}
                </th>

                <th onClick={() => sortAndToggleOrder("substage_name")}>
                  Sub Stages{" "}
                  {sortedColumn === "substage_name" && (
                    <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                  )}{" "}
                </th>
                <th onClick={() => sortAndToggleOrder("region_name")}>
                  Region Name{" "}
                  {sortedColumn === "region_name" && (
                    <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                  )}{" "}
                </th>

                {/* <th onClick={() => sortAndToggleOrder('origin_contact_person')}>Sender Name {sortedColumn === 'origin_contact_person' && <span >{sortOrder === 'asc' ? '↑' : '↓'}</span>}</th>
                <th onClick={() => sortAndToggleOrder('destination_contact_person')}>Receiver Name {sortedColumn === 'destination_contact_person' && <span >{sortOrder === 'asc' ? '↑' : '↓'}</span>}</th>
                <th onClick={() => sortAndToggleOrder('origin_contact_no')}>Sender Contact Number {sortedColumn === 'origin_contact_no' && <span >{sortOrder === 'asc' ? '↑' : '↓'}</span>}</th>
                <th onClick={() => sortAndToggleOrder('destination_contact_no')}>Receiver Contact Number {sortedColumn === 'destination_contact_no' && <span >{sortOrder === 'asc' ? '↑' : '↓'}</span>}</th>
                <th onClick={() => sortAndToggleOrder('staffView')}>Staff View {sortedColumn === 'staffView' && <span >{sortOrder === 'asc' ? '↑' : '↓'}</span>}</th>

                <th onClick={() => sortAndToggleOrder('message')}>Message {sortedColumn === 'message' && <span >{sortOrder === 'asc' ? '↑' : '↓'}</span>}</th> */}
              </tr>
            </thead>
            {loading ? (
              <div style={{ position: "relative", left: "540px" }}>
                <Loader />
              </div>
            ) : (
              <tbody>
                {visibleData?.length > 0 ? (
                  visibleData.map((item, index) => (
                    <tr key={index}>
                      {/* key={leadReport.id} */}
                      <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                      <td> <a onClick={() => nextPage1(item.lead_id)} style={{ fontWeight: "bold", cursor: "pointer" }} > {item.lead_id}</a> </td>
                      <td>{item.lead_entry_date}</td>
                      <td>{item.lead_last_update_date}</td>
                      <td>{item.followup_date}</td>
                      <td>{item.next_follow_up_date}</td>
                      <td>{item.relocation_date}</td>
                      <td>{item.total_followups}</td>
                      <td>{item.lead_owner}</td>

                      <td>{item.service_type}</td>
                      <td>{item.lead_region}</td>
                      <td>{item.leadsource}</td>
                      <td>
                        <b
                          style={{
                            height: "30px",
                            width: "100px",
                            color: "white",
                            fontWeight: "bold",
                            textAlign: "center",
                            padding: "6px",
                            borderRadius: "15px",
                            backgroundColor: getStatusColor(item.status_name),
                          }}
                        >
                          {" "}{item.status_name}{" "}
                        </b>
                      </td>
                      <td>{item.openLeadStage}</td>
                      <td>{item.closedLeadStage}</td>
                      <td>{item.call_status}</td>
                      <td>{item.call_duration}</td>
                      <td>{item.department_name}</td>
                      <td>{item.description}</td>
                      <td>{item.relocation_purpose}</td>
                      <td>{item.from_where}</td>
                      <td>{item.first_name} </td>
                      <td>{item.last_name}</td>
                      <td>{item.gender}</td>
                      <td>{item.email}</td>
                      <td>{item.mobile_no}</td>
                      <td>{item.alternate_number}</td>
                      <td>{item.pet_Name}</td>
                      <td>{item.pet_type}</td>
                      <td>{item.pet_breed}</td>
                      <td>{item.pet_gender}</td>
                      <td>{item.pet_dob}</td>
                      <td>{item.pet_age}</td>
                      <td>{item.number_of_pets}</td>
                      <td>{item.pet_behaviour}</td>
                      <td>{item.pet_length}</td>
                      <td>{item.pet_height}</td>
                      <td>{item.container_length}</td>
                      <td>{item.pet_width}</td>
                      <td>{item.origin_country}</td>
                      <td>{item.origin_state}</td>
                      <td>{item.origin_city}</td>
                      <td>{item.origin_pin}</td>
                      <td>{item.destination_country}</td>
                      <td>{item.destination_state}</td>
                      <td>{item.destination_city}</td>
                      <td>{item.destination_pin}</td>
                      <td>{item.available_slot}</td>
                      <td>{item.mode_of_transport}</td>
                      <td>{item.relocation_detail}</td>
                      <td>{item.pick_up_distance}</td>
                      <td>{item.drop_distance}</td>
                      <td>{item.container_lengtd}</td>
                      <td>{item.subject}</td>
                      <td>{item.remark}</td>

                      <td>{item.assigned_to}</td>
                      <td>{item.substage_name}</td>
                      <td>{item.region_name}</td>
                      {/* <td>{item.origin_contact_person}</td>
                      <td>{item.destination_contact_person}</td>
                      <td>{item.origin_contact_no}</td>
                      <td>{item.destination_contact_no}</td>

                      <td>{item.staffView}</td>

                      <td>{item.message}</td> */}
                    </tr>
                  ))
                ) : (
                  <p>empty</p>
                )}
              </tbody>
            )}
          </table>
        </div>
      </div>

      <nav
        aria-label="Page navigation"
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginTop: "1rem",
        }}
      >
        <ul className="pagination">
          <li className="page-item">
            <a
              className="page-link"
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
              style={{ color: "#6A6A6A" }}
            >
              Previous
            </a>
          </li>
          <li className="page-item">
            <a
              className="page-link"
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
              style={{ color: "#5B489D" }}
            >
              {currentPage - 1}
            </a>
          </li>
          <li className="page-item active">
            <a className="page-link" style={{ backgroundColor: "#5B489D" }}>
              {currentPage}
            </a>
          </li>
          <li className="page-item">
            <a
              className="page-link"
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={endIndex >= leadResponse?.length}
              style={{ color: "#5B489D" }}
            >
              {currentPage + 1}
            </a>
          </li>
          <li className="page-item">
            <a
              className="page-link"
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={endIndex >= leadResponse?.length}
              style={{ color: "#5B489D" }}
            >
              Next
            </a>
          </li>
        </ul>
      </nav>
    </>
  );
};

export default LeadDataReport;
